"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRAP_APP_PROTOCOL_ID = exports.DeviceTrapSQLMap = exports.DeviceTrapKeys = exports.DeviceTrapFields = exports.DeviceEventSeverity = exports.DeviceEventSQLMap = exports.DeviceEventKeys = exports.DeviceEventFields = exports.DeviceEventFieldOptions = exports.DeviceCollectionMethods = exports.DEVICE_INDEX_MAX_RESULTS = void 0;
const DeviceEventFields = exports.DeviceEventFields = {
  timestamp: 'INT64_00',
  facility: 'INT05',
  severity: 'INT06',
  dataset: 'STR00',
  transport: 'INT00',
  format: 'INT01',
  message: 'STR05'
};
/**
 * Value to Key mapping of DeviceEventFields, for SQL.
 */
const DeviceEventSQLMap = exports.DeviceEventSQLMap = Object.fromEntries(Object.entries(DeviceEventFields).map(([key, value]) => [value, key]));

/**
 * Key to Key mapping of DeviceEventFields, for type hinting on frontend.
 */
const DeviceEventKeys = exports.DeviceEventKeys = Object.keys(DeviceEventFields).reduce((acc, key) => {
  acc[key] = key;
  return acc;
}, {});
const DeviceEventSeverity = exports.DeviceEventSeverity = ['emergency', 'alert', 'critical', 'error', 'warning', 'notice', 'info', 'debug'];

// Multi-token values must be alphabetically sorted (matches the snmp_collection_method form `in` transform)
const DeviceCollectionMethods = exports.DeviceCollectionMethods = {
  disabled: '',
  agentFlow: 'kentik_agent_flow_only',
  agent: 'kentik_agent',
  saasFlow: 'direct_to_saas',
  kproxyAgent: 'kentik_agent,kproxy',
  kproxy: 'kproxy'
};

/**
 * Mapping of valid filter field keys across to their corresponding values.
 * NOTE THAT ORDERING IS IMPORTANT HERE! All of these values convert into a numeric value in the DB.
 *
 * TODO pull from dictionary instead?
 */
const DeviceEventFieldOptions = exports.DeviceEventFieldOptions = {
  severity: DeviceEventSeverity,
  transport: ['unknown', 'tcp', 'udp', 'unix'],
  facility: ['Kernel', 'User', 'Mail', 'Daemon', 'Auth', 'Syslog', 'LPR', 'News', 'UUCP', 'Cron', 'Authpriv', 'FTP', 'NTP', 'Security', 'Console', 'Solaris-Cron', 'Local0', 'Local1', 'Local2', 'Local3', 'Local4', 'Local5', 'Local6', 'Local7'],
  format: ['unknown', 'rfc5424', 'rfc3164', 'autodetect']
};

// most device index entries a single request can ask for or return
const DEVICE_INDEX_MAX_RESULTS = exports.DEVICE_INDEX_MAX_RESULTS = 250;

/** App protocol ID of the SNMP traps event dataset (`event_snmp_traps`). */
const TRAP_APP_PROTOCOL_ID = exports.TRAP_APP_PROTOCOL_ID = 10033;
const DeviceTrapFields = exports.DeviceTrapFields = {
  timestamp: 'INT64_01',
  trap_type: 'INT00',
  parsed_pdu: 'STR58',
  parsed_kv: 'STR24'
};
/**
 * Value to Key mapping of DeviceTrapFields, for SQL.
 */
const DeviceTrapSQLMap = exports.DeviceTrapSQLMap = Object.fromEntries(Object.entries(DeviceTrapFields).map(([key, value]) => [value, key]));

/**
 * Key to Key mapping of DeviceTrapFields, for type hinting on frontend.
 */
const DeviceTrapKeys = exports.DeviceTrapKeys = Object.keys(DeviceTrapFields).reduce((acc, key) => {
  acc[key] = key;
  return acc;
}, {});